import usePageSEO from '@/hooks/usePageSEO';
import { useLanguage } from '@/contexts/LanguageContext';
import PageLayout from '@/components/feature/PageLayout';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import ContactMap from './components/ContactMap';
import ContactFAQ from './components/ContactFAQ';
import ContactCTA from './components/ContactCTA';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://www.juuliang.com';

export default function Contact() {
  const { lang } = useLanguage();

  usePageSEO({
    title: {
      zh: '聯絡我們｜聚量應用材料股份有限公司 — 廢棄塑膠再生 · 循環經濟 · ESG 合作',
      en: 'Contact Us | PolyQ Applied Materials Co., Ltd. — Plastic Waste Recycling · Circular Economy · ESG Cooperation',
      ja: 'お問い合わせ | 聚量応用材料株式会社 — 廃プラスチック再生・サーキュラーエコノミー・ESG協力',
    },
    description: {
      zh: '聯絡聚量應用材料，與我們討論 PQernel、PQMB、塑膠再生、循環經濟、低碳材料、ESG 專案、經銷合作與技術導入。',
      en: 'Contact PolyQ Applied Materials to discuss PQernel, PQMB, plastic recycling, circular economy, low-carbon materials, ESG projects, distribution partnerships, and technology implementation.',
      ja: '聚量応用材料にお問い合わせいただき、PQernel・PQMB・廃プラスチック再生・サーキュラーエコノミー・低炭素材料・ESGプロジェクト・販売代理協力・技術導入についてご相談ください。',
    },
    keywords: {
      zh: '聯絡聚量, 塑膠再生諮詢, 循環經濟合作, PQernel, 低碳材料, ESG 專案, 技術導入, 經銷合作, 聚量應用材料聯絡',
      en: 'contact PolyQ, plastic recycling consultation, circular economy cooperation, PQernel, low-carbon materials, ESG projects, technology implementation, distribution partnership, PolyQ Applied Materials contact',
      ja: '聚量お問い合わせ, プラスチック再生相談, サーキュラーエコノミー協力, PQernel, 低炭素材料, ESGプロジェクト, 技術導入, 販売代理協力, 聚量応用材料連絡先',
    },
    path: '/contact',
    jsonLd: {
      '@type': 'ContactPage',
      name: (lang === 'en' ? 'Contact Us' : lang === 'ja' ? 'お問い合わせ' : '聯絡我們'),
      url: siteUrl + '/contact',
      description: (lang === 'en'
        ? 'Contact PolyQ Applied Materials to discuss PQernel, PQMB, plastic recycling, circular economy, low-carbon materials, and ESG projects.'
        : lang === 'ja'
          ? '聚量応用材料にお問い合わせいただき、PQernel・PQMB・廃プラスチック再生・ESGプロジェクトについてご相談ください。'
          : '聯絡聚量應用材料，與我們討論 PQernel、PQMB、塑膠再生、循環經濟、低碳材料、ESG 專案。'),
    },
  });

  return (
    <PageLayout>
      <ContactHero />
      <ContactInfo />
      <ContactFAQ />
      <ContactForm />
      <ContactMap />
      <ContactCTA />
    </PageLayout>
  );
}